export const approximate = (n: number, threshold: number) => Math.ceil(n / threshold) * threshold;
